import { render, staticRenderFns } from "./SocialTabMob.vue?vue&type=template&id=4143fe13&scoped=true"
import script from "./SocialTabMob.vue?vue&type=script&lang=js"
export * from "./SocialTabMob.vue?vue&type=script&lang=js"
import style0 from "./SocialTabMob.vue?vue&type=style&index=0&id=4143fe13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143fe13",
  null
  
)

export default component.exports